export default "__VITE_ASSET__DZpilb23__"